import React, { useState } from "react";
import CustomTypography from "../../components/CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import { useStyles } from "../../assets/jss/SearchResult";
import CustomBox from "../../components/CustomComponents/CustomBox/CustomBox";
import CustomTabs from "../../components/CustomComponents/CustomTabs/CustomTabs";
import CustomTab from "../../components/CustomComponents/CustomTab/CustomTab";
import PropTypes from "prop-types";
import SearchResultGroupTab from "../../components/SearchResultGroupTab/SearchResultGroupTab";
import qs from "querystring";
import { adminSearchResult } from "../../services/AdminSearchService";
import ErrorAlert from "../../components/ErrorAlert/ErrorAlert";
import { useHistory } from "react-router-dom";
import CustomCircularProgress from "../../components/CustomComponents/CustomCircularProgress/CustomCircularProgress";
import {
    EntityAccess,
    RBAC_CODE,
    SearchCriteria,
    TableComponentCodes,
} from "../../config/app-globals.enum";
import { getSearchType, getUserRBAC, setSearchStringForTC } from "../../services/LocalStorageService";
import CustomButton from "../../components/CustomComponents/CustomButton/CustomButton";
import NoResultImg from "../../assets/images/noResult.png";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import PraisoTableWrapper from "../../components/CustomComponents/PraisoTable/PraisoTableWrapper";

export default function SearchResult(props) {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const [getRBAC_AdminSearchResultUserView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_SEARCH_RESULT_USER_VIEW, props)
    );
    const [getRBAC_AdminSearchResultGroupView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_SEARCH_RESULT_GROUP_VIEW, props)
    );
    const history = useHistory();
    // const [isApiFailed, setIsApiFailed] = React.useState(false);
    const [isApi, setIsApi] = React.useState(false);
    const [searchData, setSearchData] = React.useState(null);
    const [statusValue, setStatusValue] = React.useState(null);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const [adminSearchKey, setAdminSearchKey] = useState(null);
    const [adminSearchType, setAdminSearchType] = useState(null);
    const [searchCriteria] = React.useState(getSearchType);
    const [resultGroupCount, setResultGroupCount] = useState(0);
    const [resultUserCount, setResultUserCount] = useState(0);
    const [resultTotalCount, setResultTotalCount] = useState(0);
    const [searchResultGroupData, setSearchResultGroupData] = useState(null);
    const [searchResultUserData, setSearchResultUserData] = useState(null);
    const [showTabIndex, setShowTabIndex] = useState(0);
    const [showAllData, setShowAllData] = useState({
        searchAll: false,
        searchType: null,
    });
    const [showTab, setShowTab] = useState(null);
    const handleTabs = (event, newTabIndex) => {
        const _showTab =
            newTabIndex === 0
                ? `${t("USERS")}`
                : newTabIndex === 1
                    ? `${t("GROUPS")}`
                    : null;
        if (showTab === _showTab) return;
        setShowTab(_showTab);
        setShowTabIndex(newTabIndex);
    };
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }
    function TabPanel(props) {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <CustomBox m={3}>{children}</CustomBox>}
            </div>
        );
    }
    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
        className: PropTypes.any,
    };

    React.useEffect(() => {
        if (props.location.pathname === "/admin/search") {
            const adminSearchQueryParams = qs.parse(props.location.search);
            if (
                adminSearchQueryParams["?searchKey"] &&
                adminSearchQueryParams["searchType"]
            ) {
                setSearchStringForTC(props.location.search);
                setAdminSearchKey(
                    adminSearchQueryParams["?searchKey"]
                        ? adminSearchQueryParams["?searchKey"]
                        : null
                );
                setAdminSearchType(
                    adminSearchQueryParams["searchType"]
                        ? adminSearchQueryParams["searchType"]
                        : null
                );
            } else {
                history.push("/admin");
            }
        }
    }, [props.location]);

    React.useEffect(() => {
        if (adminSearchType >= 0) {
            if (parseInt(adminSearchType) === parseInt(SearchCriteria.Groups)) {
                setShowTabIndex(1);
                setShowTab(t("GROUPS"));
            } else {
                setShowTabIndex(0);
                setShowTab(t("USERS"));
            }
        }
    }, [adminSearchType]);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    React.useEffect(() => {

        const searchType = adminSearchType ? adminSearchType : "0";
        async function getSearchResult() {
            setStatusValue(null);
            setAlertMessage("");
            setIsApi(true);
            const data = await adminSearchResult({
                searchString: adminSearchKey,
                searchType: searchType,
            });
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setSearchData(data.content);
                setIsApi(false);
            } else {
                setIsApi(false);
                changeApiStatusCodeFunc(data.status);
            }
        }

        if (adminSearchKey || adminSearchType) {
            getSearchResult();
        }
    }, [adminSearchKey, adminSearchType]);

    function getSearchData() {
        if (searchData) {
            if (showAllData && showAllData.searchAll) {
                if (
                    showAllData.searchType &&
                    showAllData.searchType.value === SearchCriteria.Groups
                ) {
                    setResultGroupCount(searchData.groupCount);
                    setSearchResultGroupData(searchData.groupList);
                }
                if (
                    showAllData.searchType &&
                    showAllData.searchType.value === SearchCriteria.Users
                ) {
                    setResultUserCount(searchData.userCount);
                    setSearchResultUserData(searchData.userList);
                }
            } else {
                setResultGroupCount(searchData.groupCount);
                setResultUserCount(searchData.userCount);
                setSearchResultGroupData(searchData.groupList);
                setSearchResultUserData(searchData.userList);
            }
            setShowAllData({
                searchAll: false,
                searchType: null,
            });
        }
    }

    React.useEffect(() => {
        getSearchData();
    }, [searchData]);

    React.useEffect(() => {
        let count = 0;
        if (
            resultGroupCount &&
            getRBAC_AdminSearchResultGroupView &&
            getRBAC_AdminSearchResultGroupView.isAccessible === EntityAccess.ALLOWED
        ) {
            count += resultGroupCount;
        }
        if (
            resultUserCount &&
            getRBAC_AdminSearchResultUserView &&
            getRBAC_AdminSearchResultUserView.isAccessible === EntityAccess.ALLOWED
        ) {
            count += resultUserCount;
        }
        setResultTotalCount(count);
    }, [resultGroupCount, resultUserCount]);

    const fetchAllRecords = (searchType) => {
        setAdminSearchKey("");
        const userSearchType = searchCriteria.find(
            (type) => type.label === searchType
        );
        setShowAllData({
            searchAll: true,
            searchType: userSearchType,
        });
        setAdminSearchType(userSearchType.value);
    };

    function NoSearchResultComp(props) {
        const { wrapperClass, searchString, searchLabel, isNoResult } = props;
        return (
            <CustomBox className={wrapperClass}>
                {isNoResult ? (
                    <img className={classes.noResultImg} alt="" src={NoResultImg} />
                ) : null}
                {isNoResult ? (
                    <CustomTypography
                        component="h1"
                        variant="h3"
                        className={clsx(classes.title, classes.titleNoResult)}
                    >
                        {t("NO_RESULT_FOUND")}
                    </CustomTypography>
                ) : null}
                <CustomTypography component="p">
                    {t("IGNORE_THE_SEARCH_RESULT_AND")}{" "}
                    <CustomButton
                        onClick={() => fetchAllRecords(searchString)}
                        className={classes.showAllLink}
                    >
                        {i18n.t("SHOW_ME_ALL_THE_LABEL", { searchLabel })}
                    </CustomButton>
                </CustomTypography>
            </CustomBox>
        );
    }
    NoSearchResultComp.propTypes = {
        wrapperClass: PropTypes.any.isRequired,
        searchString: PropTypes.string.isRequired,
        searchLabel: PropTypes.string.isRequired,
        isNoResult: PropTypes.bool.isRequired,
    };

    return (
        <>
            {isApi ? (
                <CustomBox className={classes.adminLayoutWrapper}>
                    <CustomGrid container spacing={0} justifyContent="center">
                        <CustomGrid
                            className={classes.adminSearchResultWrapper}
                            item
                            xs={12}
                            lg={8}
                        >
                            <CustomCircularProgress />
                        </CustomGrid>
                    </CustomGrid>
                </CustomBox>
            ) : (
                <CustomBox className={classes.adminLayoutWrapper}>
                    <CustomGrid container spacing={0} justifyContent="center">
                        <CustomGrid item xs={12} lg={8}>
                            <CustomTypography
                                component="h1"
                                variant="h5"
                                className={classes.headingTitle}
                            >
                                {i18n.t("COUNT_OF_RESULT_FOUND", {
                                    resultCount: resultTotalCount,
                                })}
                            </CustomTypography>
                        </CustomGrid>
                    </CustomGrid>
                    <CustomGrid container spacing={4} justifyContent="center">
                        <CustomGrid item xs={12}>
                            <CustomBox className={classes.searchtabsWrapper}>
                                <CustomTabs
                                    value={showTabIndex}
                                    onChange={handleTabs}
                                    aria-label="simple tabs example"
                                    indicatorColor="primary"
                                    className={classes.searchtabs}
                                >
                                    {getRBAC_AdminSearchResultUserView &&
                                        getRBAC_AdminSearchResultUserView.isAccessible ===
                                        EntityAccess.ALLOWED ? (
                                        <CustomTab
                                            label={
                                                <span className={classes.tabLabelInner}>
                                                    {t("USERS")}{" "}
                                                    <span className={classes.tabBadge}>
                                                        {resultUserCount}
                                                    </span>
                                                </span>
                                            }
                                            {...a11yProps(0)}
                                        />
                                    ) : null}
                                    {getRBAC_AdminSearchResultGroupView &&
                                        getRBAC_AdminSearchResultGroupView.isAccessible ===
                                        EntityAccess.ALLOWED ? (
                                        <CustomTab
                                            label={
                                                <span className={classes.tabLabelInner}>
                                                    {t("GROUPS")}{" "}
                                                    <span className={classes.tabBadge}>
                                                        {resultGroupCount}
                                                    </span>
                                                </span>
                                            }
                                            {...a11yProps(1)}
                                        />
                                    ) : null}
                                </CustomTabs>
                            </CustomBox>
                            {getRBAC_AdminSearchResultUserView &&
                                getRBAC_AdminSearchResultUserView.isAccessible ===
                                EntityAccess.ALLOWED ? (
                                <TabPanel
                                    key="tab-panel-users"
                                    value={showTabIndex}
                                    index={0}
                                    className={classes.tabPanel}
                                >
                                    {searchResultUserData && searchResultUserData.length ? (
                                        <>
                                            <NoSearchResultComp
                                                wrapperClass={classes.showAllWrapper}
                                                searchString={t("USERS")}
                                                searchLabel={t("USERS")}
                                                isNoResult={false}
                                            />
                                            {searchResultUserData && searchResultUserData.length ? (
                                                <PraisoTableWrapper
                                                    tableSettingView={TableComponentCodes.USER_SEARCH_RESULTS}
                                                    getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.USER_SEARCH_RESULTS}`}
                                                    preFetchedTableData={searchResultUserData}
                                                    callBackFun={getSearchData}
                                                    {...props}
                                                />
                                            ) : null}
                                        </>
                                    ) : (
                                        <NoSearchResultComp
                                            wrapperClass={classes.noResultWrapper}
                                            searchString={t("USERS")}
                                            searchLabel={t("USERS")}
                                            isNoResult={true}
                                        />
                                    )}
                                </TabPanel>
                            ) : null}
                            {getRBAC_AdminSearchResultGroupView &&
                                getRBAC_AdminSearchResultGroupView.isAccessible ===
                                EntityAccess.ALLOWED ? (
                                <TabPanel
                                    key="tab-panel-groups"
                                    value={showTabIndex}
                                    index={1}
                                    className={classes.tabPanel}
                                >
                                    {searchResultGroupData && searchResultGroupData.length ? (
                                        <>
                                            <NoSearchResultComp
                                                wrapperClass={classes.showAllWrapper}
                                                searchString={t("GROUPS")}
                                                searchLabel={t("GROUPS")}
                                                isNoResult={false}
                                            />
                                            <SearchResultGroupTab
                                                searchResultData={searchResultGroupData}
                                            />
                                        </>
                                    ) : (
                                        <NoSearchResultComp
                                            wrapperClass={classes.noResultWrapper}
                                            searchString={t("GROUPS")}
                                            searchLabel={t("GROUPS")}
                                            isNoResult={true}
                                        />
                                    )}
                                </TabPanel>
                            ) : null}
                        </CustomGrid>
                    </CustomGrid>
                </CustomBox>
            )}
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
